"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPrefs = exports.NotifPrefsSchema = exports.mapPrefsGroup = exports.getPrefByGroupId = exports.isPrefEnabledQuery = exports.isPrefEnabled = exports.setPref = void 0;
const nestGet_1 = __importDefault(require("../nestGet"));
const nestSet_1 = __importDefault(require("../nestSet"));
const config_1 = require("./config");
const setPref = (object, pref, value) => ((0, nestSet_1.default)(object, pref.keys, value));
exports.setPref = setPref;
const isPrefEnabled = (model, pref, prefsField = 'notifPrefs') => {
    var _a;
    return (((_a = (0, nestGet_1.default)(model, [prefsField, ...pref.keys])) !== null && _a !== void 0 ? _a : pref.whenUndefined) === true);
};
exports.isPrefEnabled = isPrefEnabled;
const isPrefEnabledQuery = (pref, prefsField = 'notifPrefs') => ({
    [`${prefsField}.${pref.keys.join('.')}`]: pref.whenUndefined ? { $ne: false } : { $eq: true },
});
exports.isPrefEnabledQuery = isPrefEnabledQuery;
const getPrefByGroupId = (groupId) => {
    let result;
    Object.values(config_1.NotifPrefs).find((prefsGroup) => {
        Object.values(prefsGroup).find((prefsMethod) => {
            result = Object.values(prefsMethod).find(({ group }) => group === groupId);
            return Boolean(result);
        });
        return Boolean(result);
    });
    return result;
};
exports.getPrefByGroupId = getPrefByGroupId;
const mapPrefsGroup = (prefsGroup, transform) => {
    let schemaPart = {};
    Object.entries(prefsGroup).forEach(([, prefsMethod]) => {
        Object.entries(prefsMethod).forEach(([, pref]) => {
            schemaPart = (0, nestSet_1.default)(schemaPart, pref.keys.slice(1), transform(pref));
        });
    });
    return schemaPart;
};
exports.mapPrefsGroup = mapPrefsGroup;
exports.NotifPrefsSchema = Object.fromEntries(Object.entries(config_1.NotifPrefs).map(([key, prefsGroup]) => ([
    key,
    (0, exports.mapPrefsGroup)(prefsGroup, () => Boolean),
])));
const defaultPrefs = (prefsGroup) => ((0, exports.mapPrefsGroup)(prefsGroup, (pref) => pref.whenUndefined));
exports.defaultPrefs = defaultPrefs;
